import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=7db13fac&"
import script from "./medical.vue?vue&type=script&lang=js&"
export * from "./medical.vue?vue&type=script&lang=js&"
import style0 from "./medical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports